import Assets from 'imports/assets.import';
import 'components/configuration_modal/configuration_modal.component.scss';
import { Colors, FontFamily, PrimaryButton } from 'utils/imports.utils';
import { ButtonSize, ButtonTypes } from 'utils/interface.utils';

interface IConfirmationModal {
  primaryText: string;
  secondaryText?: string;
  acceptHandle: Function;
  acceptBtnText: string;
  rejectHandle: Function;
  rejectBtnText: string;
  closeModal: Function;
  isDestructive?: boolean;
  // Project name shown in bold ahead of secondaryText; destructive layout only.
  highlightText?: string;
}

// The destructive layout uses rounded-rectangle buttons (the default outlined button is a pill).
const DESTRUCTIVE_BUTTON_STYLE = { borderRadius: '10px' };

const ConfirmationModal = (props: IConfirmationModal) => {
  const handleModalClose = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if ((e.target as HTMLDivElement).className.includes('confirmation_modal')) {
      props.closeModal();
    }
  };

  return (
    <div className="confirmation_modal" onClick={handleModalClose}>
      <div className={`confirmation_modal_container${props.isDestructive ? ' confirmation_modal_container_destructive' : ''}`}>
        {props.isDestructive && (
          <>
            <div
              onClick={() => props.closeModal()}
              className="confirmation_modal_destructive_close">
              <img
                className="confirmation_modal_close_img"
                src={Assets.close_black}
                alt="Close Modal Icon"></img>
            </div>
          </>
        )}
        <div className="confirmation_modal_header">
          <div className="confirmation_modal_primary_text">
            {props.primaryText}
          </div>
          {!props.isDestructive && (
          <div
            onClick={() => props.closeModal()}
            className="confirmation_modal_close_container">
            <img
              className="confirmation_modal_close_img"
              src={Assets.close_black}
              alt="Close Modal Icon"></img>
          </div>
          )}
        </div>
        <div>
          <div className="confirmation_modal_secondary_text">
            {props.highlightText && (
              <strong className="confirmation_modal_highlight">{props.highlightText} </strong>
            )}
            {props.secondaryText}
          </div>
        </div>
        <div className="confirmation_modal_button_container">
          <div className="confirmation_modal_button_reject">
            <PrimaryButton
              type={ButtonTypes.OUTLINED}
              size={ButtonSize.MEDIUM}
              text={props.rejectBtnText}
              onClick={props.rejectHandle}
              fontFamily={FontFamily.medium}
              color={Colors.fontSecondary}
              style={{ borderColor: '#9CA3AF', ...(props.isDestructive ? DESTRUCTIVE_BUTTON_STYLE : {}) }}
            />
          </div>
          <div className="confirmation_modal_button_accept">
            <PrimaryButton
              onClick={props.acceptHandle}
              style={props.isDestructive ? DESTRUCTIVE_BUTTON_STYLE : undefined}
              backgroundColor={props.isDestructive ? Colors.error : Colors.primaryColor}
              color={props.isDestructive ? Colors.white : undefined}
              fontFamily={FontFamily.medium}
              size={ButtonSize.MEDIUM}
              text={props.acceptBtnText}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
